<template>
  <div class="title">
    <div class="title-bg" :class="{ 'scrollChange': titleIsChange || selectedNav === '关于我们' }">
      <div class="title-cont">
        <div class="cont-left" @click="changeTile($event)">
          <img v-if="!titleIsChange"
            src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/logo@2x.png" :data-id="'首页'"
            alt="">
          <img v-else src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/logo2@2x.png" alt=""
            :data-id="'首页'">
          <!-- <span>淘宝五星级服务商<br />蝉联京东京卓奖</span> -->
          <div class="cont-left-text">
            <span>
              国内电商SaaS领导品牌
            </span>
            <span>
              跨境电商服务领航者
            </span>
          </div>
        </div>
        <div class="cont-right" @click="changeTile($event)">
          <span class="navItem"
            :class="{ 'selectedNav': navItem === selectedNav, 'selectedNav2': titleIsChange && navItem === selectedNav }"
            v-for="navItem in titleNav" :key="navItem" :data-id="navItem" @mouseover="navMouseIn(navItem)"
            @mouseleave="navMouseOut(navItem)" @click="count('导航-' + navItem)">


            <a-popover v-if="navItem === '跨境电商托管'" >
              <template slot="content">
                <div class="op-li"
                  @click="routerToUrl('https://marketplace.lazada.com.my/web/detail.html?articleCode=FW_GOODS-1000014864')">
                  <img src="@/assets/officialWebsiteImgs/shopee.png" style="width: 26px;height: auto;margin-right: 10px"  >
                
                  Lazada 托管</div>
                <div class="op-li" @click="routerToUrl('https://service.shopeecb.cn/shop-management/1004/product-49')">
                  <img src="@/assets/officialWebsiteImgs/lazada.png" style="width: 26px;height: auto;margin-right: 10px" >
                  Shopee 托管</div>
              </template>
              {{ navItem }}
            </a-popover>
            <span :data-id="navItem" @click="count('导航-' + navItem)" v-else> {{ navItem }} </span>
          </span>
          <div class="callMe">
            <img v-if="!titleIsChange"
              src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/phone@2x.png" alt="">
            <img v-else src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/phone2@2x.png" alt="">
            <span>购买、加盟咨询</span><br />
            <span>13588241409</span>
          </div>
        </div>
      </div>
      <div class="pull" :class="{ 'openPull': drawer1IsShow, 'openPull2': drawer2IsShow }"
        @mouseover="navMouseIn('pull')" @mouseleave="navMouseOut('pull')">
        <div class="pull-con">
          <div class="pullList" v-for="pullItem in pullData" :key="pullItem.title">
            <span>{{ pullItem.title }}</span>
            <div class="pullItem" v-for="item in pullItem.dataList" :key="item.title1"
              :class="{ 'selectedPull': selectedPullItem === item.title1 + pullItem.title, 'notitlePullItem': item.title2 === '', 'notitlePullItemTwo': item.isTwoRow }"
              @click="clickPullItem(item.route, item.title1, pullItem.title)">
              <img :src="item.img" alt="">
              <div class="itemText">
                <span>{{ item.title1 }}</span>
                <span>{{ item.title2 }}</span>
              </div>
            </div>
          </div>
          <div v-if="drawer2IsShow" class="line"></div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { baiduStatistics, creatImgToStatistics } from "../../utils/common"
export default {
  name: 'Syb',
  data() {
    return {
      titleNav: ['首页', '软件服务', '国内电商托管', '跨境电商托管', '电商教育', '关于我们'],
      selectedNav: '首页',
      titleIsChange: false,
      isAboutUs: false,
      drawer1IsShow: false,
      drawer2IsShow: false,
      inPull: '',
      tools: [
        {
          title: '淘系推广工具',
          dataList: [
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/syb@2x.png', title1: '省油宝', title2: '万相台无界智能优化软件', isFirst: true, route: 'https://fuwu.taobao.com/ser/detail.htm?service_code=ts-1796606' },
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/syzt@2x.png', title1: '省油智投', title2: '万相台+直通车一站式推广', route: 'https://fuwu.taobao.com/ser/detail.htm?service_code=ts-1797607&spm=a21lp.26139860.0.0.3c0341064nSfTX&code=ts-1797607' },
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/cjmf@2x.png', title1: '超级魔方', title2: '引力魔方精准圈人群自动优化软件', route: 'https://fuwu.taobao.com/ser/detail.htm?spm=a1z13.pc_search_result.1234-fwlb.42.23905acarJe2Rm&service_code=FW_GOODS-1001021058' },
            // { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/jm@2x.png', title1: '聚麦报表', title2: '直通车+引力魔方一站式报表软件', route: '/jmReport' },
          ],
        },
        // {
        //   title: '拼多多系推广工具',
        //   dataList: [
        //     { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/xmzt@2x.png', title1: '小麦智投', title2: '拼多多推广自动优化软件', isFirst: true, route: '/xmDetail' },
        //   ],
        // },
        {
          title: '京东系推广工具',
          dataList: [
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/syb@2x.png', title1: '省油快车', title2: '京东快车自动优化软件', isFirst: true, route: 'https://fw.jd.com/main/detail/FW_GOODS-385001?p=fw&t=pcsearch' },
          ],
        }, {
          title: '跨境电商推广工具',
          dataList: [
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/addImg2023/AIMAX-02.png', title1: 'AIMAX省油宝', title2: 'lazada广告投放软件', isFirst: true, route: 'https://marketplace.lazada.com.my/web/detail.html?articleCode=FW_GOODS-1000015005' },
          ],
        }
      ],
      serves: [
        {
          title: '淘系服务',
          dataList: [
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/ztc@2x.png', title1: '万相台无界代运营服务', title2: '8年经验车手手动代开，为您降本增效', isFirst: true, route: '/tbReplace' },
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/dyy@2x.png', title1: '全店代运营服务', title2: '10年店长+专业运营+推广+美工+助理为您打造高盈利店铺', route: '/wholeShop' },
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/ylmf@2x.png', title1: '引力魔方代运营服务', title2: '资深车手代推引力魔方，显著提升转化', route: '/ylReplace' },
          ],
        },
        {
          title: '拼多多服务',
          dataList: [
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/pdd@2x.png', title1: '拼多多推广托管', title2: '专家车手代开，为您降本增效', isFirst: true, route: '/pddReplace' },
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/dyy@2x.png', title1: '全店代运营服务', title2: '资深店长+专业运营+推广+美工+助理为您打造高盈利店铺', route: '/wholeShop' },
          ],
        },
        {
          title: '京东系服务',
          dataList: [
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/jd@2x.png', title1: '京东快车托管', title2: '类目专家车手代开，为您降本增效', isFirst: true, route: '/jdReplace' },
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/dyy@2x.png', title1: '全店代运营', title2: '资深店长+专业运营+推广+美工+助理为您打造高盈利店铺', route: '/wholeShop' },
          ],
        },
        {
          title: '1688系服务',
          dataList: [
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/dyy@2x.png', title1: '全店代运营服务', title2: '资深店长+专业运营+推广+美工+助理为您打造高盈利店铺', isFirst: true, route: '/wholeShop' },
          ],
        },

        {
          title: '抖音系服务',
          dataList: [
            { img: require('@/assets/officialWebsiteImgs/douyin.png'), title1: '抖店托管/推广', title2: '直播跟播、千川投放、抖店装修、DOU+投放', route: 'http://www.maimiaotech.com/' },
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/dyy@2x.png', title1: '全店代运营服务', title2: '资深店长+专业运营+推广+美工+助理 为您打造高盈利店铺', route: '/wholeShop' },

          ],
        },
        {
          title: '设计服务',
          dataList: [
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/tt@2x.png', title1: '头图制作', title2: '', isFirst: true, route: '/designServe?top=1', isTwoRow: true },
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/xqy@2x.png', title1: '详情页制作', title2: '', route: '/designServe?top=2', isTwoRow: true },
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/cy@2x.png', title1: '创意图制作', title2: '', route: '/designServe?top=3', isTwoRow: true },
            { img: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/by@2x.png', title1: '设计包月', title2: '', route: '/designServe?top=4', isTwoRow: true },
          ],
        },


      ],
      pullData: [],
      selectedPullItem: '',
      scorllNum: 0,
      isGoOther: false,
      routerNav: {
        Home: '首页',
        XmDetail: '软件服务',
        WholeShop: '国内电商托管',
        CeCommerce: '跨境电商托管',
        Education: '电商教育',
        About: '关于我们',
      }
    }
  },
  beforeMount() {
    this.selectedNav = this.routerNav[this.$router.history.current.name]
    if (this.$router.history.current.name === 'About' || this.$router.history.current.name === 'Buy' || this.$router.history.current.name === 'DesignServe') {
      this.titleIsChange = true
      this.isAboutUs = true
    }
  },
  mounted() {
    window.addEventListener('scroll', this.changeScroll)
    this.pullData = this.tools
  },
  methods: {
    // 滚动条发生改变时
    changeScroll() {
      if (this.selectedNav !== '关于我们' && this.$router.history.current.name !== 'Buy' && this.$router.history.current.name !== 'DesignServe') {
        let scrollNum = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (this.isAboutUs || this.drawer1IsShow || this.drawer2IsShow) return
        this.titleIsChange = scrollNum > 10
        this.scorllNum = scrollNum
      }

    },
    // 点击导航时
    changeTile(e) {
      if (!e.target.dataset.id) { return }
      this.isAboutUs = false
      this.selectedNav = e.target.dataset.id
      switch (e.target.dataset.id) {
        case '首页':
          creatImgToStatistics({ from: 'mm_fuwu_index', service_code: 'ts-1796606' })
          this.$router.push('/')
          break;
        case '软件服务':
          this.$router.push('/promote')
          break;
        case '国内电商托管':
          this.$router.push('/wholeShop')
          break;
        case '跨境电商托管':
          this.$router.push({ path: '/cbeCommerce' })
          break;
        case '电商教育':
          this.$router.push({ path: '/education' })
          break;
        case '关于我们':
          this.$router.push('/about')
          this.titleIsChange = true
          this.isAboutUs = true
          break;
      }
    },
    // 鼠标移入导航
    navMouseIn(key) {
      // 鼠标移入下拉模块
      if (key === 'pull') {
        this.inPull === '软件服务' ? this.drawer1IsShow = true : this.drawer2IsShow = true
        this.isGoOther = true
        this.titleIsChange = true
        return
      }
      if (key === '软件服务' || key === '国内电商托管') {
        this.titleIsChange = true
        key === '软件服务' ? this.drawer1IsShow = true : this.drawer2IsShow = true
        this.pullData = key === '软件服务' ? this.tools : this.serves
      }
    },
    //鼠标移出
    navMouseOut(key) {
      //  if (this.scorllNum === 0) this.titleIsChange = false
      if (key === '软件服务' || key === '国内电商托管' || key === 'pull') {
        this.drawer1IsShow = false
        this.drawer2IsShow = false
        this.inPull = key
        if (this.scorllNum >= 0) { return }
        this.titleIsChange = false
      }
    },
    // 点击选择后关闭
    clickPullItem(route, key, groupKey) {
      // console.log("代运营服务", route, key, groupKey);
      this.selectedPullItem = key + groupKey
      switch (key) {
        case '省油宝':
          creatImgToStatistics({ from: 'syb_01', service_code: 'ts-1796606' })
          break;
        case '省油智投':
          creatImgToStatistics({ from: 'syzk_01', service_code: 'FW_GOODS-1001182971' })
          break;
        case '超级魔方':
          creatImgToStatistics({ from: 'cjmf_01', service_code: 'FW_GOODS-1001021058' })
          break;
        case '聚麦报表':
          creatImgToStatistics({ from: 'jmbb_01', service_code: 'FW_GOODS-1001095544' })
          break;
        case '省油快车':
          creatImgToStatistics({ from: 'sykc_01', service_code: 'FW_GOODS-385001' })
          break;
        case '小麦智投':
          creatImgToStatistics({ from: 'xmzt_01', service_code: 'PDD_FW_GOODS-385001' })
          break;
        case '直通车代运营服务':
          creatImgToStatistics({ from: 'ztcd_02', service_code: 'simba_service' })
          break;
        case '全店代运营服务':
          if (groupKey === '淘系服务') {
            creatImgToStatistics({ from: 'tbqdd_02', service_code: 'simba_whole_shop_service' })
          }
          if (groupKey === '拼多多服务') {
            creatImgToStatistics({ from: 'pddqdd_02', service_code: 'pdd_whole_shop_service' })
          }
          if (groupKey === '1688系服务') {
            creatImgToStatistics({ from: '1688qd_02', service_code: '1688_whole_shop_service' })
          }
          break;
        case '引力魔方代运营服务':
          creatImgToStatistics({ from: 'ylmfd_02', service_code: 'ylmf_service' })
          break;
        case '拼多多推广托管':
          creatImgToStatistics({ from: 'pddtg_02', service_code: 'pdd_service' })
          break;
        case '京东快车托管':
          creatImgToStatistics({ from: 'jdkctg_02', service_code: 'jd_service' })
          break;
        case '全店代运营':
          creatImgToStatistics({ from: 'jdqd_02', service_code: 'jd_whole_shop_service' })
          break;
        case '头图制作':
          creatImgToStatistics({ from: 'ttzz_03', service_code: 'picutre_service' })
          break;
      }
      if (route.includes('http')) {
        window.open(route)
      } else {
        this.$router.push(route)
      }
      if (key === '全店代运营服务') {
        if (groupKey === '淘系服务') { this.$router.push('/wholeShop') }
        if (groupKey === '京东系服务') { this.$router.push('/wholeShop') }
        if (groupKey === '拼多多系服务') { this.$router.push('/wholeShop') }
        if (groupKey === '1688系服务') { this.$router.push('/wholeShop') }
      }
      this.selectedNav = this.drawer1IsShow ? '软件服务' : '国内电商托管';
      this.drawer1IsShow = false
      this.drawer2IsShow = false
      let threeText = this.selectedNav === '国内电商托管' ? groupKey + '-' : ''
      this.count('导航-' + this.selectedNav + '-' + threeText + key)

    },
    routerToUrl(url) {
      window.open(url)
    },
    count(text, key = 'click') {
      console.log('啊哈哈哈', text, key)
      baiduStatistics(text, key)
    }
  },
  watch: {
    $route(to) {
      if (to.name === 'About' || to.name === 'Buy' || to.name === 'DesignServe') {
        this.isAboutUs = true
      }
      console.log('this.routerNav[to.name]', to.name, this.routerNav[to.name]);
      this.titleIsChange = true
      this.selectedNav = this.routerNav[to.name]
    }
  }

}
</script>
<style lang="less">
.title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 9999;

  &-bg {
    width: 100%;
    min-width: 1200px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);

    .title-cont {
      width: 1200px;
      min-width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      margin-bottom: -1px;
      height: 61px;

      .cont-left {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          display: inline-block;
          height: 26px;
          width: 80px;
          margin-right: 15px;
          cursor: pointer;
        }

        .cont-left-text {
          display: inline-block;
          width: 152px;
          color: #fff;
          font-size: 13px;
          font-weight: 500;
          font-family: PingFang;
          padding-left: 15px;
          text-align: left;
          line-height: 17px;
          border-left: 1px solid #e1e1e1;
        }
      }

      .cont-right {
        color: #fff;
        display: flex;
        align-items: center;

        .navItem {
          padding: 19px 0 18px 0;
          margin: 0 20px;
          font-size: 18px;
          font-weight: 400;
          cursor: pointer;
        }

        .selectedNav {
          border-bottom: 3px solid #fff;
        }

        .selectedNav2 {
          border-bottom: 3px solid #2c87ee;
          color: #2c87ee;
        }

        .callMe {
          padding: 5px 0;
          text-align: left;
          margin-left: 60px;

          img {
            height: 13px;
            width: 13px;
            margin-right: 3px;
          }

          span {
            font-size: 14px;
            font-family: PingFang SC;
          }

          span:last-child {
            font-size: 18px;
          }
        }
      }
    }

    .pull {
      height: 0px;
      background-color: #ffffff;
      top: 62px;
      position: absolute;
      box-shadow: 0px 11px 20px 0px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      padding: 0 0 0 20px;

      &-con {
        width: 1200px;
        display: flex;
        flex-wrap: wrap;

        .pullList {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-right: 20px;
          padding: 20px 0 0 0;

          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #3c4254;
            padding: 10px;
          }

          .pullItem {
            display: flex;
            width: 280px;
            min-height: 70px;
            padding-top: 8px;
            cursor: pointer;

            img {
              width: 30px;
              height: 30px;
              margin: 10px 0 0 15px;
            }

            .itemText {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              padding: 5px 10px;
              text-align: left;

              span {
                color: #3c4254;
                padding: 0;
              }

              span:last-child {
                font-size: 12px;
                margin-top: 3px;
                color: #aeb0bb;
              }
            }
          }

          .pullItem:hover {
            background: #ecf0f5;
          }

          .selectedPull {
            background: #ecf0f5;
          }

          .notitlePullItem {
            align-items: center;

            img {
              margin: 0 0 0 15px;
            }
          }

          .notitlePullItemTwo {
            padding: 0;
            min-height: 55px;
          }
        }

        .pullList:nth-child(4) {}

        .line {
          width: 1124px;
          height: 1px;
          border: 1px solid #f0f1f6;
          position: absolute;
          top: 49%;
          left: calc(50% - 562px);
        }
      }
    }

    .openPull {
      transition: 0.2s height ease-in-out;
      height: 349px;
    }

    .openPull2 {
      transition: 0.2s height ease-in-out;
      height: 580px;
    }
  }
}

.scrollChange {
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);

  span {
    color: #7b7b7b !important;
  }
}

.op-li {
  cursor: pointer;
  height: 40px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
</style>
<style>
.ant-popover-placement-bottom {
  z-index: 10000 !important;
}
</style>
